import { EmployeesEmployeeAvatarFragment } from 'generated/resources/graphql'

import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

export const normalizeEmployee = (employee: Employee): EmployeesEmployeeAvatarFragment => {
  const user = employeeUser(employee)

  return {
    __typename: 'EmployeesEmployee',
    id: employee.id,
    access: {
      id: user.id,
      fullName: user.fullName(),
      avatar: user.avatar,
    },
  }
}
